import { message as antdMessage } from 'antd';
import type { MessageInstance, ArgsProps } from 'antd/es/message/interface';

// 기본 duration 설정 (4초)
const DEFAULT_DURATION = 4;
const MAX_COUNT = 5;

// message 설정 초기화
antdMessage.config({
  duration: DEFAULT_DURATION,
  maxCount: MAX_COUNT,
});

// Custom message wrapper with guaranteed duration
export const message: MessageInstance = {
  success: (content: ArgsProps | string) => {
    if (typeof content === 'string') {
      return antdMessage.success({ content, duration: DEFAULT_DURATION });
    }
    return antdMessage.success({ ...content, duration: content.duration ?? DEFAULT_DURATION });
  },

  error: (content: ArgsProps | string) => {
    if (typeof content === 'string') {
      return antdMessage.error({ content, duration: DEFAULT_DURATION });
    }
    return antdMessage.error({ ...content, duration: content.duration ?? DEFAULT_DURATION });
  },

  info: (content: ArgsProps | string) => {
    if (typeof content === 'string') {
      return antdMessage.info({ content, duration: DEFAULT_DURATION });
    }
    return antdMessage.info({ ...content, duration: content.duration ?? DEFAULT_DURATION });
  },

  warning: (content: ArgsProps | string) => {
    if (typeof content === 'string') {
      return antdMessage.warning({ content, duration: DEFAULT_DURATION });
    }
    return antdMessage.warning({ ...content, duration: content.duration ?? DEFAULT_DURATION });
  },

  loading: (content: ArgsProps | string) => {
    if (typeof content === 'string') {
      // Loading은 일반적으로 더 긴 duration이 필요
      return antdMessage.loading({ content, duration: 30 });
    }
    // duration: 0이면 30초로 변경 (무한 대기 방지)
    const adjustedDuration = content.duration === 0 ? 30 : (content.duration ?? 30);
    return antdMessage.loading({ ...content, duration: adjustedDuration });
  },

  open: (config: ArgsProps) => {
    return antdMessage.open({ ...config, duration: config.duration ?? DEFAULT_DURATION });
  },

  destroy: (key?: React.Key) => {
    antdMessage.destroy(key);
  },

  config: antdMessage.config,
  useMessage: antdMessage.useMessage,
} as MessageInstance;

// 강제로 모든 메시지를 파괴하는 함수
export const destroyAllMessages = () => {
  antdMessage.destroy();
};

// 디버깅용 - 현재 설정 확인
export const checkMessageConfig = () => {
  console.log('Message configuration:', {
    defaultDuration: DEFAULT_DURATION,
    maxCount: MAX_COUNT,
  });
};